import './PercentageBar.pcss';
import * as React from 'react';
import * as classnames from 'classnames';
import { abbreviateNumber, getPercentage } from '@mm/utils';

type Props = {
  total: number;
  used: number;
  className?: string;
  title?: string;
  cardLayout?: boolean;
  useOverTotal?: boolean;
  showUsedNumber?: boolean;
  showTotalNumber?: boolean;
  customPercentClass?: string;
  percentageBarClassName?: string;
  bodyWrapperStyle?: string;
  showUsedNumberRightSide?: boolean;
};

const getUsedNumberStyle = (usedPercent: number) => {
  if (5 > usedPercent) {
    return { left: '0' };
  }

  return { left: `calc(${usedPercent}% - 30px)` };
};

export const PercentageBar = (props: Props) => {
  const {
    total,
    used,
    className,
    title,
    cardLayout,
    customPercentClass,
    percentageBarClassName,
    useOverTotal = true,
    showUsedNumber = true,
    showTotalNumber = true,
    bodyWrapperStyle,
    showUsedNumberRightSide,
  } = props;
  const usedPercent = getPercentage(used, total);
  const usedNumberStyle = getUsedNumberStyle(usedPercent);
  const overTotal = used >= total;
  const classList = classnames('percentage-bar', className, {
    'percentage-bar--over-total': useOverTotal && overTotal,
    'percentage-bar--card-layout': cardLayout,
  });

  const percentStyle = {
    width: `${usedPercent}%`,
  };

  const totalNumberStyle = total < 10 ? { right: '-35px' } : { right: '-45px' };

  return (
    <div className={classList}>
      {title && <div className="percentage-bar__title">{title}</div>}

      <div
        className={classnames('percentage-bar__body-wrapper', bodyWrapperStyle)}
      >
        {cardLayout && showUsedNumber && !showUsedNumberRightSide && (
          <div
            className="percentage-bar__card-used-number"
            style={usedNumberStyle}
          >
            {abbreviateNumber(used)}
          </div>
        )}

        <div
          className={classnames('percentage-bar__bar', percentageBarClassName)}
        >
          <div
            style={percentStyle}
            className={classnames(
              {
                'percentage-bar__used-percentage-low':
                  !customPercentClass && usedPercent < 50,
                'percentage-bar__used-percentage':
                  !customPercentClass && usedPercent > 50,
              },
              customPercentClass,
            )}
          />

          {showTotalNumber && !showUsedNumberRightSide && (
            <div
              className="percentage-bar__total-number"
              style={totalNumberStyle}
            >
              {abbreviateNumber(total)}
            </div>
          )}
        </div>

        {cardLayout && showUsedNumberRightSide && (
          <div
            className="percentage-bar__card-used-number-right-side"
            style={usedNumberStyle}
          >
            {abbreviateNumber(used)}
          </div>
        )}

        {!cardLayout && (
          <div className="percentage-bar__numbers-wrapper">
            {!overTotal && (
              <div
                className="percentage-bar__used-number"
                style={usedNumberStyle}
              >
                {abbreviateNumber(used)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
